import { definePlugin, defineAIActions } from '@kernel/core/plugin-loader';

// AI 动作定义
const aiActions = defineAIActions({
  namespace: 'team',
  actions: [
    {
      id: 'assign-task',
      name: '智能分配任务',
      description: '根据成员能力智能分配任务',
      parameters: [
        { name: 'taskTitle', type: 'string', description: '任务标题', required: true },
        { name: 'priority', type: 'string', description: '优先级', required: false },
      ],
      handler: async (params) => {
        // 模拟智能分配逻辑
        return {
          type: 'action',
          data: {
            taskTitle: params.taskTitle,
            assignedTo: '运营小红',
            reason: '该成员近期任务完成率高，且擅长此类任务',
          },
          message: '任务已智能分配给最合适的成员',
        };
      },
    },
  ],
});

// 导出插件定义
export default definePlugin({
  meta: {
    name: 'team-collab',
    version: '1.0.0',
    displayName: '团队协作',
    description: '团队成员管理、角色权限、任务分配',
    icon: 'user-cog',
    category: 'system',
  },

  onLoad: async () => {
    console.log('[Plugin] Team Collab loaded');
  },

  onUnload: () => {
    console.log('[Plugin] Team Collab unloaded');
  },

  routes: [
    {
      path: '/team',
      lazy: async () => {
        const { TeamMembers } = await import('./pages/TeamMembers');
        return { Component: TeamMembers };
      },
    },
    {
      path: '/team/roles',
      lazy: async () => {
        const { RoleManagement } = await import('./pages/RoleManagement');
        return { Component: RoleManagement };
      },
    },
    {
      path: '/team/tasks',
      lazy: async () => {
        const { TaskBoard } = await import('./pages/TaskBoard');
        return { Component: TaskBoard };
      },
    },
    {
      path: '/team/logs',
      lazy: async () => {
        const { AuditLogs } = await import('./pages/AuditLogs');
        return { Component: AuditLogs };
      },
    },
  ],

  sidebarMenus: [
    {
      id: 'team',
      title: '团队协作',
      icon: 'user-cog',
      path: '/team',
      order: 8,
    },
  ],

  aiActions,
});

